import React from 'react';
import { Button, Tooltip, makeStyles, Typography } from '@material-ui/core/';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';
import { isEmpty, isNil } from 'lodash';

const useStyles = makeStyles((theme) => ({
	copyBtn: {
		fontSize: '1rem',
		cursor: 'copy',
		alignItems: 'center',
		height: '1.5em',
	},
}));
// Component to display field with copy to clipboard button.
function CopyClipboardField({ val, fieldName }) {
	const classes = useStyles();
	const titleMsg = `Click to copy the ${fieldName} to the clipboard.`;
	// don't render copy button when value is empty.
	if (!isEmpty(val) && !isNil(val)) {
		return (
			<Tooltip title={titleMsg} arrow={true} placement="top">
				<Button
					className={classes.copyBtn}
					size="small"
					color="inherit"
					endIcon={<CopyIcon color="primary" />}
					onClick={() => {
						navigator.clipboard.writeText(val);
					}}
				>
					<Typography variant="body2" display="inline">
						{val}
					</Typography>
				</Button>
			</Tooltip>
		);
	}
	return null;
}

export default CopyClipboardField;
